
export enum EmoteDictionary {
    Blank,
    OneDot,
    TwoDots,
    ThreeDots,
    BrokenHeart,
    Heart,
    Hearts,
    ExclamationMarks,
    ExclamationMark,
    QuestionMark,
    Z,
    ZZ,
    FeelingDown,
    SmileyFace,
    SadFace,
    AngryFace,
    SurpriseEffect,
    Star,
    ConfuseEffect,
    Music,
    RainDrop,
    RainDrops,
    AngryEffect,
    DollarSign,
    ConfuseCoil,
    Wrong,
    Correct,
    LightBulb,
    HaHa,
    Cloud,
    Play,
    Replay,
    Share,
    Live,
    Badge
}

export enum AnswerState {
    None,
    Correct,
    Wrong
}

export enum GameState {
    BeforeGame,
    DuringGame,
    EndGame,
    Transition
}

export enum ScreenOrientation {
    Portrait,
    Landscape
}

export enum ScreenAnchor {
    Top,
    Bottom,
    Center
}

export enum SoundEffect {
    Confirmation = './sounds/drop_002.mp3',
    Delete = './sounds/back_002.mp3',
    Correct = './sounds/drop_002.mp3',
    Wrong = './sounds/back_002.mp3',
}